var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Shape from './Shape';
import { polygonBBox } from '../utils/bbox';
import { pointInPolygonFill, pointInPolygonStroke } from '../geometry/contain/polygon';
import { getPolylineCornerRadiusPoints } from '../geometry/cornerRadius';
import { MonotoneX, MonotoneY, CatmullRomClosed, Natural } from '../geometry/curve';
var shapeKeys = [
    'pointList',
    'smooth',
    'smoothMonotone',
];
var Polyline = /** @class */ (function (_super) {
    __extends(Polyline, _super);
    function Polyline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'polyline';
        _this.shapeKeys = shapeKeys;
        return _this;
    }
    Polyline.prototype.getDefaultAttr = function () {
        return __assign(__assign({}, _super.prototype.getDefaultAttr.call(this)), { pointList: [], smooth: false });
    };
    Polyline.prototype.getAnimationKeys = function () {
        return __spreadArrays(_super.prototype.getAnimationKeys.call(this), ['pointList']);
    };
    Polyline.prototype.brush = function (ctx) {
        var _a = this.attr, pointList = _a.pointList, smoothMonotone = _a.smoothMonotone;
        var borderRadius = this.getExtendAttr('borderRadius') || 0;
        var isPolygon = this.type === 'polygon';
        if (!pointList || pointList.length === 0) {
            return;
        }
        if (this.attr.smooth) {
            var CurveUse = void 0;
            if (this.type === 'polygon') {
                CurveUse = CatmullRomClosed;
            }
            else {
                if (smoothMonotone === 'x') {
                    CurveUse = MonotoneX;
                }
                else if (smoothMonotone === 'y') {
                    CurveUse = MonotoneY;
                }
                else {
                    CurveUse = Natural;
                }
            }
            var curve_1 = new CurveUse(ctx);
            curve_1.lineStart();
            pointList.forEach(function (point) { return curve_1.point(point.x, point.y); });
            curve_1.lineEnd();
        }
        else {
            ctx.moveTo(pointList[0].x, pointList[0].y);
            var radiusIndex = -1;
            for (var i = isPolygon ? 0 : 1; i < pointList.length; i++) {
                radiusIndex++;
                if (!borderRadius) {
                    ctx.lineTo(pointList[i].x, pointList[i].y);
                }
                else {
                    var r = Array.isArray(borderRadius) ? (borderRadius[radiusIndex] || 0) : borderRadius;
                    var p1 = pointList[i - 1];
                    var p2 = pointList[i];
                    var p3 = pointList[i + 1];
                    var isFirstPolygonPoint = !p1 && isPolygon;
                    if (isFirstPolygonPoint) {
                        p1 = pointList[pointList.length - 1];
                    }
                    if (!p3 && isPolygon) {
                        p3 = pointList[0];
                    }
                    this.lineToWithBorderRadius(ctx, p1, p2, p3, r, isFirstPolygonPoint);
                }
            }
        }
    };
    Polyline.prototype.lineToWithBorderRadius = function (ctx, p1, p2, p3, borderRadius, noLineTo) {
        if (!p3 && this.type === 'polyline') {
            return ctx.lineTo(p2.x, p2.y);
        }
        var _a = getPolylineCornerRadiusPoints([p1.x, p1.y], [p2.x, p2.y], [p3.x, p3.y], borderRadius), radius = _a.radius, startPoint = _a.startPoint, startAngle = _a.startAngle, endAngle = _a.endAngle, center = _a.center, clocWise = _a.clocWise;
        if (!noLineTo) {
            ctx.lineTo(startPoint[0], startPoint[1]);
        }
        else {
            ctx.moveTo(startPoint[0], startPoint[1]);
        }
        ctx.arc(center[0], center[1], radius, startAngle, endAngle, !clocWise);
    };
    Polyline.prototype.computeBBox = function () {
        if (!this.attr.smooth) {
            return polygonBBox(this.attr.pointList);
        }
        return this.getPathData().getPathBBox();
    };
    Polyline.prototype.isPointInFill = function (x, y) {
        var points = this.attr.pointList;
        return pointInPolygonFill(points, x, y);
    };
    Polyline.prototype.isPointInStroke = function (x, y, lineWidth) {
        var points = this.attr.pointList;
        return pointInPolygonStroke(points, false, lineWidth, x, y);
    };
    Polyline.prototype.pickByGPU = function () {
        return this.attr.smooth;
    };
    return Polyline;
}(Shape));
export default Polyline;
